'use client';

import { c as _c } from "react/compiler-runtime";
import { Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { siteConfig } from '@/config/site';
import Image from 'next/image';
import Link from 'next/link';
export default function Footer() {
  const $ = _c(144);
  const t = useTranslations("Footer");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Image src="/7-laux-mtb-location-snowboard-ski-vtt-reparation-atelier-rental.webp" alt="La Grange 7 Laux Logo" width={120} height={120} className="flex-shrink-0 h-16 w-auto sm:h-20" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("brandHeading");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex items-center gap-4">{t0}<h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold font-[family-name:var(--font-bebas-neue)] text-foreground tracking-tight">{t1}</h2></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Phone className="h-6 w-6 sm:h-7 sm:w-7 flex-shrink-0" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("callUs");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <a href="tel:+33476717226" className="flex flex-col sm:flex-row items-center justify-center text-center gap-1.5 sm:gap-2 px-2 py-3 sm:py-4 bg-[url('/leather.jpg')] bg-cover bg-center text-black rounded-lg text-base sm:text-lg lg:text-xl font-bold leading-tight border border-[#2a1f10]/50 [text-shadow:0_1px_0_rgba(255,240,214,0.55)] shadow-lg transition-all hover:scale-105 hover:brightness-105">{t3}<span>{t4}</span></a>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Mail className="h-6 w-6 sm:h-7 sm:w-7 flex-shrink-0" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("emailUs");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <a href="mailto:lagrangeauxskis@outlook.com" className="flex flex-col sm:flex-row items-center justify-center text-center gap-1.5 sm:gap-2 px-2 py-3 sm:py-4 bg-[url('/leather.jpg')] bg-cover bg-center text-black rounded-lg text-base sm:text-lg lg:text-xl font-bold leading-tight border border-[#2a1f10]/50 [text-shadow:0_1px_0_rgba(255,240,214,0.55)] shadow-lg transition-all hover:scale-105 hover:brightness-105">{t6}<span>{t7}</span></a>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <MapPin className="h-6 w-6 sm:h-7 sm:w-7 flex-shrink-0" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("getDirections");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <a href="https://www.google.com/maps/dir/?api=1&destination=45.25666211408852,5.997889227471393&destination_place_id=ChIJka6aJ3FEeko1450VASzHQDU" target="_blank" rel="noopener noreferrer" className="flex flex-col sm:flex-row items-center justify-center text-center gap-1.5 sm:gap-2 px-2 py-3 sm:py-4 bg-[url('/leather.jpg')] bg-cover bg-center text-black rounded-lg text-base sm:text-lg lg:text-xl font-bold leading-tight border border-[#2a1f10]/50 [text-shadow:0_1px_0_rgba(255,240,214,0.55)] shadow-lg transition-all hover:scale-105 hover:brightness-105">{t9}<span>{t10}</span></a>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t5 || $[22] !== t8) {
    t12 = <div className="grid grid-cols-3 gap-2 sm:gap-3">{t5}{t8}{t11}</div>;
    $[20] = t11;
    $[21] = t5;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div><p className="font-bold">Les Granges des 7 Laux</p><p>Chalet B, 38190 PRAPOUTEL</p></div>;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t) {
    t14 = t("openingHoursTitle");
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14) {
    t15 = <p className="font-bold">{t14}</p>;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t) {
    t16 = t("openingHoursWinter");
    $[29] = t;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16) {
    t17 = <p className="font-medium">{t16}</p>;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t) {
    t18 = t("openingHoursSummer");
    $[33] = t;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t18) {
    t19 = <p className="font-medium">{t18}</p>;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t15 || $[38] !== t17 || $[39] !== t19) {
    t20 = <div className="-mt-1 flex flex-col sm:flex-row sm:flex-wrap gap-4 sm:gap-x-12 text-base sm:text-lg">{t13}<div>{t15}{t17}{t19}</div></div>;
    $[37] = t15;
    $[38] = t17;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t) {
    t21 = t("followUs");
    $[41] = t;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t21) {
    t22 = <span className="text-sm font-semibold text-foreground uppercase tracking-wider">{t21}</span>;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <a href={siteConfig.social.instagram} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors p-2.5 hover:bg-accent rounded-lg" aria-label="Instagram" title="Follow us on Instagram"><Instagram className="h-7 w-7" /></a>;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="flex items-center gap-2">{t23}<a href={siteConfig.social.facebook} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors p-2.5 hover:bg-accent rounded-lg" aria-label="Facebook" title="Follow us on Facebook"><Facebook className="h-7 w-7" /></a></div>;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t22) {
    t25 = <div className="flex items-center gap-3">{t22}{t24}</div>;
    $[47] = t22;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t12 || $[50] !== t2 || $[51] !== t20 || $[52] !== t25) {
    t26 = <div className="flex flex-col gap-6">{t2}{t12}{t20}{t25}</div>;
    $[49] = t12;
    $[50] = t2;
    $[51] = t20;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="h-72 sm:h-80 lg:h-auto lg:min-h-[440px] rounded-xl overflow-hidden shadow-xl border"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d175.53508485313898!2d5.997889227471393!3d45.25666211408852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478a45271aa96691%3A0x35047bc01150e8e3!2sLa%20Grange%20Prapoutel%20Les%207%20Laux!5e0!3m2!1sen!2sfr!4v1760973879886!5m2!1sen!2sfr" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="La Grange Prapoutel - Location Map" /></div>;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t26) {
    t28 = <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-8 items-stretch">{t26}{t27}</div>;
    $[55] = t26;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="flex items-center gap-2 mb-5 pb-2 border-b border-border/30"><span className="text-3xl">🇫🇷</span><h3 className="font-semibold text-xl font-[family-name:var(--font-bebas-neue)] tracking-wide">Français</h3></div>;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <li><Link href="/fr" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Accueil</Link></li>;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  let t32;
  let t33;
  let t34;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <li className="pt-2"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Été</span></li>;
    t32 = <li><Link href="/fr/7laux-bike-parc-vtt-enduro-descente-ebike-alpes" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t33 = <li><Link href="/fr/7laux-location-vtt-descente-ebike" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Location & Atelier"}</Link></li>;
    t34 = <li><Link href="/fr/7laux-location-reservation-entretien-atelier-vtt-descente-enfant-protection" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"R\xE9servation & Contact"}</Link></li>;
    $[59] = t31;
    $[60] = t32;
    $[61] = t33;
    $[62] = t34;
  } else {
    t31 = $[59];
    t32 = $[60];
    t33 = $[61];
    t34 = $[62];
  }
  let t35;
  let t36;
  let t37;
  let t38;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <li className="pt-3"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Hiver</span></li>;
    t36 = <li><Link href="/fr/7laux-ski-snowboard-domaine-skiable-alpes-familles" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t37 = <li><Link href="/fr/7laux-location-ski-snowboard-equipement" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Location & Atelier"}</Link></li>;
    t38 = <li><Link href="/fr/7laux-location-reservation-entretien-atelier-ski-snowboard-snowscoot" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"R\xE9servation & Contact"}</Link></li>;
    $[63] = t35;
    $[64] = t36;
    $[65] = t37;
    $[66] = t38;
  } else {
    t35 = $[63];
    t36 = $[64];
    t37 = $[65];
    t38 = $[66];
  }
  let t39;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <div>{t29}<ul className="space-y-2.5">{t30}{t31}{t32}{t33}{t34}{t35}{t36}{t37}{t38}<li className="pt-2"><Link href="/fr/mentions-legales" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Mentions Légales</Link></li></ul></div>;
    $[67] = t39;
  } else {
    t39 = $[67];
  }
  let t40;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <div className="flex items-center gap-2 mb-5 pb-2 border-b border-border/30"><span className="text-3xl">🇬🇧</span><h3 className="font-semibold text-xl font-[family-name:var(--font-bebas-neue)] tracking-wide">English</h3></div>;
    $[68] = t40;
  } else {
    t40 = $[68];
  }
  let t41;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <li><Link href="/en" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Home</Link></li>;
    $[69] = t41;
  } else {
    t41 = $[69];
  }
  let t42;
  let t43;
  let t44;
  let t45;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <li className="pt-2"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Summer</span></li>;
    t43 = <li><Link href="/en/7laux-bike-park-mtb-enduro-downhill-ebike-alps" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t44 = <li><Link href="/en/7laux-mtb-rental-downhill-ebike" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Rental & Workshop"}</Link></li>;
    t45 = <li><Link href="/en/7laux-rental-booking-maintenance-workshop-mtb-downhill-kids-protection" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Booking & Contact"}</Link></li>;
    $[70] = t42;
    $[71] = t43;
    $[72] = t44;
    $[73] = t45;
  } else {
    t42 = $[70];
    t43 = $[71];
    t44 = $[72];
    t45 = $[73];
  }
  let t46;
  let t47;
  let t48;
  let t49;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <li className="pt-3"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Winter</span></li>;
    t47 = <li><Link href="/en/7laux-ski-snowboard-ski-area-alps-families" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t48 = <li><Link href="/en/7laux-ski-snowboard-rental-equipment" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Rental & Workshop"}</Link></li>;
    t49 = <li><Link href="/en/7laux-rental-booking-maintenance-workshop-ski-snowboard-snowscoot" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Booking & Contact"}</Link></li>;
    $[74] = t46;
    $[75] = t47;
    $[76] = t48;
    $[77] = t49;
  } else {
    t46 = $[74];
    t47 = $[75];
    t48 = $[76];
    t49 = $[77];
  }
  let t50;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <div>{t40}<ul className="space-y-2.5">{t41}{t42}{t43}{t44}{t45}{t46}{t47}{t48}{t49}<li className="pt-2"><Link href="/en/mentions-legales" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Legal Notice</Link></li></ul></div>;
    $[78] = t50;
  } else {
    t50 = $[78];
  }
  let t51;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <div className="flex items-center gap-2 mb-5 pb-2 border-b border-border/30"><span className="text-3xl">🇳🇱</span><h3 className="font-semibold text-xl font-[family-name:var(--font-bebas-neue)] tracking-wide">Nederlands</h3></div>;
    $[79] = t51;
  } else {
    t51 = $[79];
  }
  let t52;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <li><Link href="/nl" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Home</Link></li>;
    $[80] = t52;
  } else {
    t52 = $[80];
  }
  let t53;
  let t54;
  let t55;
  let t56;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <li className="pt-2"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Zomer</span></li>;
    t54 = <li><Link href="/nl/7laux-bikepark-mtb-enduro-downhill-ebike-alpen" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t55 = <li><Link href="/nl/7laux-mtb-verhuur-downhill-ebike" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Verhuur & Werkplaats"}</Link></li>;
    t56 = <li><Link href="/nl/7laux-verhuur-boeking-onderhoud-werkplaats-mtb-downhill-kinderen-bescherming" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Reservering & Contacteer"}</Link></li>;
    $[81] = t53;
    $[82] = t54;
    $[83] = t55;
    $[84] = t56;
  } else {
    t53 = $[81];
    t54 = $[82];
    t55 = $[83];
    t56 = $[84];
  }
  let t57;
  let t58;
  let t59;
  let t60;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <li className="pt-3"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Winter</span></li>;
    t58 = <li><Link href="/nl/7laux-ski-snowboard-skigebied-alpen-gezinnen" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t59 = <li><Link href="/nl/7laux-ski-snowboard-verhuur-uitrusting" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Verhuur & Werkplaats"}</Link></li>;
    t60 = <li><Link href="/nl/7laux-verhuur-boeking-onderhoud-werkplaats-ski-snowboard-snowscoot" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Reservering & Contacteer"}</Link></li>;
    $[85] = t57;
    $[86] = t58;
    $[87] = t59;
    $[88] = t60;
  } else {
    t57 = $[85];
    t58 = $[86];
    t59 = $[87];
    t60 = $[88];
  }
  let t61;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <div>{t51}<ul className="space-y-2.5">{t52}{t53}{t54}{t55}{t56}{t57}{t58}{t59}{t60}<li className="pt-2"><Link href="/nl/mentions-legales" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Juridische Kennisgeving</Link></li></ul></div>;
    $[89] = t61;
  } else {
    t61 = $[89];
  }
  let t62;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <div className="flex items-center gap-2 mb-5 pb-2 border-b border-border/30"><span className="text-3xl">🇪🇸</span><h3 className="font-semibold text-xl font-[family-name:var(--font-bebas-neue)] tracking-wide">Español</h3></div>;
    $[90] = t62;
  } else {
    t62 = $[90];
  }
  let t63;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = <li><Link href="/es" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Inicio</Link></li>;
    $[91] = t63;
  } else {
    t63 = $[91];
  }
  let t64;
  let t65;
  let t66;
  let t67;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = <li className="pt-2"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Verano</span></li>;
    t65 = <li><Link href="/es/7laux-parque-bicicletas-mtb-enduro-descenso-ebike-alpes" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t66 = <li><Link href="/es/7laux-alquiler-mtb-descenso-ebike" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Alquiler & Taller"}</Link></li>;
    t67 = <li><Link href="/es/7laux-alquiler-reserva-mantenimiento-taller-mtb-descenso-ninos-proteccion" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Reserva & Contacto"}</Link></li>;
    $[92] = t64;
    $[93] = t65;
    $[94] = t66;
    $[95] = t67;
  } else {
    t64 = $[92];
    t65 = $[93];
    t66 = $[94];
    t67 = $[95];
  }
  let t68;
  let t69;
  let t70;
  let t71;
  if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = <li className="pt-3"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Invierno</span></li>;
    t69 = <li><Link href="/es/7laux-esqui-snowboard-estacion-esqui-alpes-familias" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t70 = <li><Link href="/es/7laux-alquiler-ski-snowboard-equipamiento" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Alquiler & Taller"}</Link></li>;
    t71 = <li><Link href="/es/7laux-alquiler-reserva-mantenimiento-taller-ski-snowboard-snowscoot" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Reserva & Contacto"}</Link></li>;
    $[96] = t68;
    $[97] = t69;
    $[98] = t70;
    $[99] = t71;
  } else {
    t68 = $[96];
    t69 = $[97];
    t70 = $[98];
    t71 = $[99];
  }
  let t72;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = <div>{t62}<ul className="space-y-2.5">{t63}{t64}{t65}{t66}{t67}{t68}{t69}{t70}{t71}<li className="pt-2"><Link href="/es/mentions-legales" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Aviso Legal</Link></li></ul></div>;
    $[100] = t72;
  } else {
    t72 = $[100];
  }
  let t73;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = <div className="flex items-center gap-2 mb-5 pb-2 border-b border-border/30"><span className="text-3xl">🇮🇹</span><h3 className="font-semibold text-xl font-[family-name:var(--font-bebas-neue)] tracking-wide">Italiano</h3></div>;
    $[101] = t73;
  } else {
    t73 = $[101];
  }
  let t74;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t74 = <li><Link href="/it" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Home</Link></li>;
    $[102] = t74;
  } else {
    t74 = $[102];
  }
  let t75;
  let t76;
  let t77;
  let t78;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = <li className="pt-2"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Estate</span></li>;
    t76 = <li><Link href="/it/7laux-bike-park-mtb-enduro-discesa-ebike-alpi" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t77 = <li><Link href="/it/7laux-noleggio-mtb-discesa-ebike" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Noleggio & Officina"}</Link></li>;
    t78 = <li><Link href="/it/7laux-noleggio-prenotazione-manutenzione-officina-mtb-discesa-bambini-protezione" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Prenotazione & Contatto"}</Link></li>;
    $[103] = t75;
    $[104] = t76;
    $[105] = t77;
    $[106] = t78;
  } else {
    t75 = $[103];
    t76 = $[104];
    t77 = $[105];
    t78 = $[106];
  }
  let t79;
  let t80;
  let t81;
  let t82;
  if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = <li className="pt-3"><span className="text-xs font-semibold text-foreground uppercase tracking-wider">Inverno</span></li>;
    t80 = <li><Link href="/it/7laux-sci-snowboard-comprensorio-sciistico-alpi-famiglie" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">7Laux</Link></li>;
    t81 = <li><Link href="/it/7laux-noleggio-sci-snowboard-attrezzatura" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Noleggio & Officina"}</Link></li>;
    t82 = <li><Link href="/it/7laux-noleggio-prenotazione-manutenzione-officina-sci-snowboard-snowscoot" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">{"Prenotazione & Contatto"}</Link></li>;
    $[107] = t79;
    $[108] = t80;
    $[109] = t81;
    $[110] = t82;
  } else {
    t79 = $[107];
    t80 = $[108];
    t81 = $[109];
    t82 = $[110];
  }
  let t83;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t83 = <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-8 pb-10 pt-10">{t39}{t50}{t61}{t72}<div>{t73}<ul className="space-y-2.5">{t74}{t75}{t76}{t77}{t78}{t79}{t80}{t81}{t82}<li className="pt-2"><Link href="/it/mentions-legales" className="text-sm text-muted-foreground hover:text-primary hover:underline underline-offset-2 transition-all">Note Legali</Link></li></ul></div></div>;
    $[111] = t83;
  } else {
    t83 = $[111];
  }
  let t84;
  if ($[112] === Symbol.for("react.memo_cache_sentinel")) {
    t84 = new Date().getFullYear();
    $[112] = t84;
  } else {
    t84 = $[112];
  }
  let t85;
  if ($[113] !== t) {
    t85 = t("rights");
    $[113] = t;
    $[114] = t85;
  } else {
    t85 = $[114];
  }
  let t86;
  if ($[115] !== t85) {
    t86 = <p className="text-xs text-muted-foreground">© {t84} LaGrange. {t85}</p>;
    $[115] = t85;
    $[116] = t86;
  } else {
    t86 = $[116];
  }
  let t87;
  if ($[117] !== t) {
    t87 = t("credit");
    $[117] = t;
    $[118] = t87;
  } else {
    t87 = $[118];
  }
  let t88;
  if ($[119] !== t) {
    t88 = t("creditName");
    $[119] = t;
    $[120] = t88;
  } else {
    t88 = $[120];
  }
  let t89;
  if ($[121] !== t88) {
    t89 = <a href="https://indiecrafts.dev" target="_blank" rel="noopener noreferrer" className="font-bold text-foreground hover:text-primary hover:underline underline-offset-2 transition-colors">{t88}</a>;
    $[121] = t88;
    $[122] = t89;
  } else {
    t89 = $[122];
  }
  let t90;
  if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
    t90 = <img src="https://indiecrafts.dev/brand/og-home.webp" alt="Indiecrafts" loading="lazy" className="h-32 w-full object-cover" />;
    $[123] = t90;
  } else {
    t90 = $[123];
  }
  let t91;
  if ($[124] === Symbol.for("react.memo_cache_sentinel")) {
    t91 = <span className="block text-sm font-semibold text-foreground">Indiecrafts</span>;
    $[124] = t91;
  } else {
    t91 = $[124];
  }
  let t92;
  if ($[125] !== t) {
    t92 = t("creditDescription");
    $[125] = t;
    $[126] = t92;
  } else {
    t92 = $[126];
  }
  let t93;
  if ($[127] !== t92) {
    t93 = <span className="mt-1 block leading-snug text-muted-foreground">{t92}</span>;
    $[127] = t92;
    $[128] = t93;
  } else {
    t93 = $[128];
  }
  let t94;
  if ($[129] === Symbol.for("react.memo_cache_sentinel")) {
    t94 = <span className="mt-1.5 block text-[11px] font-medium text-primary">indiecrafts.dev</span>;
    $[129] = t94;
  } else {
    t94 = $[129];
  }
  let t95;
  if ($[130] !== t93) {
    t95 = <span className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 w-[min(18rem,calc(100vw-2rem))] max-w-[calc(100vw-2rem)] -translate-x-1/2 translate-y-1 opacity-0 transition-all duration-200 group-hover:translate-y-0 group-hover:opacity-100 group-focus-within:translate-y-0 group-focus-within:opacity-100"><span className="block overflow-hidden rounded-xl border border-border bg-card text-left shadow-xl">{t90}<span className="block p-3">{t91}{t93}{t94}</span></span></span>;
    $[130] = t93;
    $[131] = t95;
  } else {
    t95 = $[131];
  }
  let t96;
  if ($[132] !== t89 || $[133] !== t95) {
    t96 = <span className="group relative inline-block">{t89}{t95}</span>;
    $[132] = t89;
    $[133] = t95;
    $[134] = t96;
  } else {
    t96 = $[134];
  }
  let t97;
  if ($[135] !== t87 || $[136] !== t96) {
    t97 = <p className="text-xs text-muted-foreground mt-1">{t87}{" "}{t96}</p>;
    $[135] = t87;
    $[136] = t96;
    $[137] = t97;
  } else {
    t97 = $[137];
  }
  let t98;
  if ($[138] !== t86 || $[139] !== t97) {
    t98 = <div className="mt-8 text-center">{t86}{t97}</div>;
    $[138] = t86;
    $[139] = t97;
    $[140] = t98;
  } else {
    t98 = $[140];
  }
  let t99;
  if ($[141] !== t28 || $[142] !== t98) {
    t99 = <footer id="contact" className="mt-12 md:mt-16 border-t bg-background"><div className="mx-auto max-w-7xl px-6 pt-20 pb-12">{t28}{t83}{t98}</div></footer>;
    $[141] = t28;
    $[142] = t98;
    $[143] = t99;
  } else {
    t99 = $[143];
  }
  return t99;
}